import * as _ from 'lodash';
import { MutableRefObject } from 'react';
import { IDonor, IMatchRunPosition, IPosition, IRecipient, ISoleSourceDonor } from '@nkr/models/index';
import { Overlay, Label } from 'react-bootstrap';
import { SsdTableWrapper } from './styles';
import { MatchStatus } from '@nkr/enums/match-status';
import PopoverTemplate from '@nkr/components/popover-template';
import SingleEpletMmRisk from '@nkr/views/swap-management/single-eplet-mm-risk';

interface IProps {
    show: boolean,
    rowRef: any,
    tableRef: MutableRefObject<any>,
    donor: IDonor,
    intendedDonors: IDonor[],
    recipient: IRecipient,
    donors: ISoleSourceDonor[],
    isMatchingPage?: boolean
}

const RecipientOverlay = (props: IProps) => {
    let { show, rowRef, tableRef, recipient, donors, intendedDonors } = props;
    let voucherDonorExpectedDonationSection: JSX.Element | null = null;

    const getWhichKidney = (donor: IDonor) => {
        if (donor.whichKidney != '' && donor.whichKidney != 'DNK') {
            let results = `${donor.whichKidneyAbbreviated}${donor.numberOfArteries}`;

            if (donor.whichKidney == 'L-opt') {
                results += '(R)';
            }

            if (donor.whichKidney == 'R-opt') {
                results += '(L)';
            }

            return results;
        }

        return '--';
    };

    const getAboCombo = (donor: IDonor) => {
        var aboC = "Missing Case (" + recipient.bloodType + "|" + donor.bloodType;

        if (recipient.bloodType != "O" && donor.bloodType == "O") {
            aboC = "Favourable";
        }
        if ((recipient.bloodType == donor.bloodType) || (recipient.bloodType != "O" && donor.bloodType != "O" && donor.bloodType != "")) {
            aboC = "Neutral";
        }

        if (recipient.bloodType == "O" && donor.bloodType != "O" && donor.bloodType.trim() != "") {
            aboC = "Unfavourable";
        }

        if (donor.bloodType == "") {
            aboC = "Donor Not Linked";
        }

        return aboC;
    }


    if (props.donor != null && props.recipient != null && props.donor.id != -1 && props.recipient.id != -1) {

        if (recipient.isAdpChip && !recipient.hasAdpDonorDonated) {

            if (recipient.adpDonor != null) {
                let {
                    donationStartDate: vdDonationStartDate,
                    donationEndDate: vdDonationEndDate,
                    statusId: vdStatusId,
                    logistics: vdLogistics,
                    alias,
                    center,
                    bloodType,
                    age
                } = recipient.adpDonor;

                let donorExpectedDonationDate = vdLogistics.kidneyPickupDateTime;

                if (vdStatusId == MatchStatus.NeedsMatch && donorExpectedDonationDate == '') {
                    donorExpectedDonationDate = '- pending match -';
                }

                let donationDateRange = `${vdDonationStartDate} - ${vdDonationEndDate}`;

                if (vdDonationStartDate == '' && vdDonationEndDate == '') {
                    donationDateRange = '- not specified -';
                }

                voucherDonorExpectedDonationSection =
                    <>
                        <h4 style={{ marginTop: 0 }}>Voucher Donor - {alias}{center != null ? ` - ${center.alias}` : ''}</h4>
                        <table>
                            <tbody>
                                <tr>
                                    <td style={{ paddingRight: 10 }}>Donation Date:</td>
                                    <td>{donorExpectedDonationDate}</td>
                                </tr>
                                <tr>
                                    <td style={{ paddingRight: 10 }}>Donation Range:</td>
                                    <td>{donationDateRange}</td>
                                </tr>
                                <tr>
                                    <td style={{ paddingRight: 10 }}>Donor ABO:</td>
                                    <td>{bloodType}</td>
                                </tr>
                                <tr>
                                    <td style={{ paddingRight: 10 }}>Donor Age:</td>
                                    <td>{age}</td>
                                </tr>
                            </tbody>
                        </table>
                    </>;
            } else {
                voucherDonorExpectedDonationSection =
                    <>
                        <h4 style={{ marginTop: 0 }}>Voucher Donor</h4>
                        <div>The voucher donor is missing or unlinked...</div>
                    </>;
            }
        }
    }

    return (
        <Overlay
            show={show}
            placement='top'
            target={() => rowRef}
            container={() => document.body}
        >
            <PopoverTemplate width='1000px' dismiss={false} style={{ pointerEvents: 'none' }}>
                {voucherDonorExpectedDonationSection && !props.isMatchingPage && (
                    <div style={{ marginBottom: 10, paddingBottom: 8, borderBottom: '1px solid #ddd' }}>
                        {voucherDonorExpectedDonationSection}
                    </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: '65fr 35fr' }}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <strong>Intended Donor</strong>
                        </div>
                        <SsdTableWrapper condensed striped bordered>
                            <thead>
                                <tr>
                                    <th>Donated</th>
                                    <th>ABO</th>
                                    <th>ABO Combo</th>
                                    <th>Age</th>
                                    <th>FAnat</th>
                                </tr>
                            </thead>
                            <tbody>
                                {intendedDonors.length > 0 ?
                                    intendedDonors.map(x => {
                                        return (
                                            <tr>
                                                <td>{x.statusId == MatchStatus.Transplanted ? 'Yes' : 'No'}</td>
                                                <td>{x.bloodTypeDisplay}</td>
                                                <td>{getAboCombo(x)}</td>
                                                <td>{x.age}</td>
                                                <td>{getWhichKidney(x)}</td>
                                            </tr>
                                        )
                                    })
                                    :
                                    <tr>
                                        <td>--</td>
                                        <td>--</td>
                                        <td>--</td>
                                        <td>--</td>
                                    </tr>
                                }
                            </tbody>
                        </SsdTableWrapper>
                    </div>

                    <div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <strong>Additional Information</strong>
                        </div>
                        <SsdTableWrapper condensed striped bordered>
                            <thead>
                                <tr>
                                    <th>Comp Pair</th>
                                    <th>Eplet Pref</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{recipient != null
                                        ? recipient.isCompatiblePair
                                            ? <Label bsStyle="success">Yes</Label>
                                            : <Label bsStyle="warning">No</Label>
                                        : '--'}
                                    </td>
                                    <td>{recipient != null ? recipient.requireEplet : ''}</td>
                                </tr>
                            </tbody>
                        </SsdTableWrapper>
                    </div>
                </div>

                {recipient != null && recipient.voucherCategories.length > 0 && (
                    <>
                        <div style={{ marginBottom: 5 }}>Match Offer Policy</div>
                        <SsdTableWrapper condensed striped bordered>
                            <thead>
                                <tr>
                                    <th>Section</th>
                                    <th>Description</th>
                                    <th>Policy</th>
                                </tr>
                            </thead>
                            <tbody>
                                {recipient.voucherCategories.map(item =>
                                    <tr>
                                        <td>{item.section}</td>
                                        <td>{item.description}</td>
                                        <td>{item.policy}</td>
                                    </tr>
                                )}
                            </tbody>
                        </SsdTableWrapper>
                    </>
                )}

                {donors.length > 0 && (
                    <>
                        <div style={{ marginBottom: 5 }}><strong>{props.donor.center.alias}</strong> donor <strong>{props.donor.alias}</strong> is <strong>sole source</strong> for the following</div>
                        <SsdTableWrapper condensed striped bordered>
                            <thead>
                                <tr>
                                    <th>Recipient</th>
                                    <th>Center</th>
                                    <th>CPR</th>
                                    <th>cPRA4</th>
                                    <th>WT</th>
                                    <th>CP</th>
                                    <th>Type</th>
                                    <th>D Age</th>
                                    <th>D ABO</th>
                                    <th>Eplet MM</th>
                                </tr>
                            </thead>
                            {donors.map(item =>
                                <tbody>
                                    <tr>
                                        <td>{item.recipientAlias}</td>
                                        <td>{item.recipientCenter}</td>
                                        <td>{item.recipientCenterCprScore}</td>
                                        <td>{item.recipientCpra4.toFixed(2)}</td>
                                        <td>{item.recipientWaitTime}</td>
                                        <td>{recipient != null
                                            ? item.epletMm.isCompatiblePair
                                                ? <Label bsStyle="success">Yes</Label>
                                                : <Label bsStyle="warning">No</Label>
                                            : '--'}
                                        </td>
                                        <td>{item.patientType}</td>
                                        <td>{item.donorId > 0 ? item.donorAge : '--'}</td>
                                        <td>{item.donorId > 0 ? item.donorBloodType : '--'}</td>
                                        <td>{item.donorId > 0 ? <SingleEpletMmRisk data={item.epletMm} isAdmin={false} centerId={item.recipientCenterId} /> : '--'}</td>
                                    </tr>
                                </tbody>
                            )}
                        </SsdTableWrapper>
                    </>
                )}
            </PopoverTemplate>
        </Overlay>
    );
}

export default RecipientOverlay;